import callApi from "@web-monorepo/infra/callApi";
import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createReducer from "@web-monorepo/infra/createReducer";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import { take, call } from "redux-saga/effects";

const STATE_KEY = "nuxMetadata";

const initialState = {
  welcomeDismissed: false,
  parentToolkitDismissed: false,
};

type State = typeof initialState;

export type NuxMetadataSlice = {
  [STATE_KEY]: State;
};

// Action Creators
export const DISMISS_WELCOME_NUX = createAction("nuxMetadata/welcome/dismiss");
export const dismissWelcomeNux = createActionCreator(DISMISS_WELCOME_NUX);

export const DISMISS_PARENT_TOOLKIT_NUX = createAction("nuxMetadata/parentToolkit/dismiss");
export const dismissParentToolkitNux = createActionCreator(DISMISS_PARENT_TOOLKIT_NUX);

// Selectors
export const selectWelcomeDismissed = (state: NuxMetadataSlice) => {
  return state?.[STATE_KEY]?.welcomeDismissed;
};

export const selectParentToolkitDismissed = (state: NuxMetadataSlice) => {
  return state?.[STATE_KEY]?.parentToolkitDismissed;
};

// Reducers
const dismissWelcomeNuxHandler = createReducer(
  DISMISS_WELCOME_NUX,
  (state: State): State => ({ ...state, welcomeDismissed: true }),
);

const dismissParentToolkitNuxHandler = createReducer(
  DISMISS_PARENT_TOOLKIT_NUX,
  (state: State): State => ({ ...state, parentToolkitDismissed: true }),
);

// Final Reducer
const finalReducer = combineActionHandlers(initialState, [dismissWelcomeNuxHandler, dismissParentToolkitNuxHandler]);

// Api Calls
export function dismissWelcomeNuxCall() {
  return callApi({
    method: "PUT",
    path: `/api/userConfig/metadata/toolkitWelcomeDismissed`,
    body: {
      value: true,
    },
  });
}

export function dismissParentToolkitNuxCall() {
  return callApi({
    method: "PUT",
    path: `/api/userConfig/metadata/parentToolkitNuxDismissed`,
    body: {
      value: true,
    },
  });
}

// Sagas
function* dismissWelcomeNuxMetadataSaga() {
  yield take(DISMISS_WELCOME_NUX);
  yield call(dismissWelcomeNuxCall);
}

function* dismissParentToolkitNuxMetadataSaga() {
  yield take(DISMISS_PARENT_TOOLKIT_NUX);
  yield call(dismissParentToolkitNuxCall);
}

const install: PodInstallFunction = (installReducer, installSaga) => {
  installReducer(STATE_KEY, finalReducer);
  installSaga(dismissWelcomeNuxMetadataSaga);
  installSaga(dismissParentToolkitNuxMetadataSaga);
};

export default install;
